module.exports = __webpack_public_path__ + "static/media/fair.b34edba5.png";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/fair.png
// module id = 488
// module chunks = 0